import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { ApiService } from '@services/api.service';
import {
  ManagementAdditionalPaymentModel,
  ManagementAdditionalPaymentsSearchPaginationModel,
  ManagementUpsertAdditionalPaymentModel,
} from '@data-layer/models/management';
import { PaginatedResultModel } from '@data-layer/models/common';

@Injectable({
  providedIn: 'root',
})
export class AdditionalPaymentsManagementRepository {
  constructor(private apiService: ApiService) {}

  public search(
    params?: ManagementAdditionalPaymentsSearchPaginationModel,
    isShowLoader: boolean = true,
  ): Observable<PaginatedResultModel<ManagementAdditionalPaymentModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementAdditionalPaymentModel>>(
      `${environment.url.prefixFreight}management/additional-quote-payments`,
      {
        params,
      },
      { isShowLoader },
    );
  }

  public get(id: number, isShowLoader: boolean = true): Observable<ManagementAdditionalPaymentModel> {
    return this.apiService.get(`${environment.url.prefixFreight}management/additional-quote-payments/${id}`, null, {
      isShowLoader,
    });
  }

  public create(
    payment: ManagementUpsertAdditionalPaymentModel,
    isShowLoader: boolean = true,
  ): Observable<ManagementAdditionalPaymentModel> {
    return this.apiService.post(`${environment.url.prefixFreight}management/additional-quote-payments`, payment, null, {
      isShowLoader,
    });
  }

  public update(
    payment: ManagementUpsertAdditionalPaymentModel,
    isShowLoader: boolean = true,
  ): Observable<ManagementAdditionalPaymentModel> {
    return this.apiService.put(`${environment.url.prefixFreight}management/additional-quote-payments/${payment.id}`, payment, null, {
      isShowLoader,
    });
  }

  public delete(id: number, isShowLoader: boolean = true): Observable<ManagementAdditionalPaymentModel> {
    return this.apiService.delete(`${environment.url.prefixFreight}management/additional-quote-payments/${id}`, null, {
      isShowLoader,
    });
  }
}
